import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetOrdersOrderIdParams, TypeGetOrdersOrderIdResponse } from '~/types/delivery-agency.types';

/**
 * [배송 주문 관리] 배송 주문 상세 조회 API
 */
const fetchOrdersOrderId = async (
  params: TypeGetOrdersOrderIdParams
): Promise<TypeGetOrdersOrderIdResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetOrdersOrderIdResponse>(
    `${API_ENDPOINT.DELIVERY_AGENCY.GET_ORDER_DETAIL}/${params.orderId}`
  );
  return data.data;
};

/**
 * [배송 주문 관리] 배송 주문 상세 조회 Mutation Hook
 */
export const useGetOrdersOrderIdMutation = () => {
  return useMutation({
    mutationFn: fetchOrdersOrderId,
  });
};
